/**
 * 환경 배지 — 화면 상단에 어느 환경의 파트너를 다루는지 표시한다(D-9). 운영(REL)은 눈에 띄는 색.
 * @spec:2026-10-14-phai-admin-외부연동키-관리화면
 */
import React from "react";
import { envLabel, isRelEnv } from "utils/partnerAdmin";
import { EnvBadgeBox } from "./style";

const EnvBadge: React.FC<{ env: string | null | undefined }> = ({ env }) => {
  if (!env) return null;
  return (
    <EnvBadgeBox $rel={isRelEnv(env)} data-testid="partner-env-badge">
      {envLabel(env)}
    </EnvBadgeBox>
  );
};

export default EnvBadge;
